import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-a-new-content-page"
    }}>{`Creating a new content page`}</h1>
    <div className="deprecation-message">
  <h2>We're moving our docs!</h2>
  <h3>
    Find{" "}
    <a href="https://depo-platform-documentation.scrollhelp.site/developer-docs/Creating-a-new-content-page.1848737888.html">
      the latest version of this page
    </a>{" "}
    on the Platform website.
  </h3>
  <h3>
    Still can't find what you're looking for? Reach out to{" "}
    <a href="https://dsva.slack.com/archives/CBU0KDSB1">
      #vfs-platform-support
    </a>{" "}
    on Slack.
  </h3>
    </div>
    <p>{`Note: Check out the `}<a parentName="p" {...{
        "href": "/veteran-facing-services-tools/getting-started/common-tasks/new-feature"
      }}>{`Adding a new feature`}</a>{` doc to make sure you're trying to add the right type of feature to VA.gov.`}</p>
    <h2 {...{
      "id": "choosing-vagov-content-or-drupal"
    }}>{`Choosing vagov-content or Drupal`}</h2>
    <p>{`There are two ways to add a new page to VA.gov; one is by adding it in vagov-content. The other is to add it to the Drupal CMS. Drupal will eventually be the only source of content, but `}<inlineCode parentName="p">{`vagov-content`}</inlineCode>{` is expected to be around for the near future.`}</p>
    <p>{`If you need to add a page to `}<inlineCode parentName="p">{`vagov-content`}</inlineCode>{`, there is `}<a parentName="p" {...{
        "href": "https://github.com/department-of-veterans-affairs/vagov-content/blob/main/docs/index.md"
      }}>{`documentation`}</a>{` in that repo. You should also contact the website team to coordinate with them on where the new page should live.`}</p>
    <p>{`If you need to add a page to Drupal, coordinate with the cms team via your project manager.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      